import { Interpolation } from '@emotion/react';
import { Icon, suppressEvent, Text, Theme, theme } from '@lbcamden/lib-react';
import { FunctionComponent } from 'react';
import { Link } from 'react-router';

import { useGoBackOrNavigate } from '~/client/hooks/useGoBackOrNavigate';

import { BreadCrumbsRoot } from './PageBreadcrumbs.styled';

export interface BreadcrumbItem {
  name: string;
  link?: string;
}

export interface Props {
  css?: Interpolation<Theme>;
  className?: string;
  links: BreadcrumbItem[];
}

export const PageBreadcrumbs: FunctionComponent<Props> = ({ links, ...props }) => {
  const goBackOrNavigate = useGoBackOrNavigate();

  return (
    <BreadCrumbsRoot {...props}>
      {links.map(({ name, link }, index) => {
        const key = `${name}:${link}`;

        const text = (
          <Text key={key} aria-current={index === links.length - 1 && 'page'}>
            {name}
          </Text>
        );

        const item = link ? (
          <Link
            onClick={suppressEvent(() => goBackOrNavigate(link), true)}
            color={theme.colors.primary}
            to={link}
            key={key}
          >
            {text}
          </Link>
        ) : (
          text
        );

        return [
          item,
          index !== links.length - 1 && <Icon key={`${key}-chevron`} icon="ui/chevron-light" />,
        ];
      })}
    </BreadCrumbsRoot>
  );
};
